import { lazy } from './lazy.ts';

export const SYNTHETIC_CHECK = 'synthetic-check';
export const CHECK_ENABLED = String(true);

export const isSyntheticCheckMode = lazy(loadIsSyntheticCheck);
export const isSyntheticCheckModeNoLazy = loadIsSyntheticCheck;
export function enableSyntheticCheckMode(url: URL) {
  url.searchParams.set(SYNTHETIC_CHECK, CHECK_ENABLED);
}

/**
 * Load the state of the synthetic check flag
 *
 * This is stored in:
 * * The URL which is used to load the flag
 * * Session storage
 */
function loadIsSyntheticCheck(): boolean {
  try {
    /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
    const win = globalThis.parent ?? window;
    const searchParams = new URLSearchParams(win.location.search);
    let value = searchParams.get(SYNTHETIC_CHECK);

    if (value !== null) {
      globalThis.sessionStorage.setItem(SYNTHETIC_CHECK, value);
    } else {
      value = globalThis.sessionStorage.getItem(SYNTHETIC_CHECK);
    }

    return value === CHECK_ENABLED;
  } catch {
    // Session storage is disabled or some other error has occurred
    // in this case disable the synthetic check mode
    return false;
  }
}

export const MEDIA_MOCK = 'media-mock';

export const isMediaMockMode = lazy(loadIsMediaMockMode);
export function enableMediaMockMode(url: URL) {
  url.searchParams.set(MEDIA_MOCK, CHECK_ENABLED);
}

/**
 * Load the state of the synthetic check flag
 *
 * This is stored in:
 * * The URL which is used to load the flag
 * * Session storage
 */
function loadIsMediaMockMode(): boolean {
  try {
    /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
    const win = globalThis.parent ?? window;
    const searchParams = new URLSearchParams(win.location.search);
    let value = searchParams.get(MEDIA_MOCK);

    if (value !== null) {
      globalThis.sessionStorage.setItem(MEDIA_MOCK, value);
    } else {
      value = globalThis.sessionStorage.getItem(MEDIA_MOCK);
    }

    return value === CHECK_ENABLED;
  } catch {
    // Session storage is disabled or some other error has occurred
    // in this case disable the synthetic check mode
    return false;
  }
}
